import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import styles from "../../font-weights.css";
const withWeightModifiers = WrappedComponent => {
  const NewComponent = /*#__PURE__*/React.forwardRef((_ref, ref) => {
    let {
      bold,
      className,
      ...props
    } = _ref;
    let classList = className;
    if (bold) {
      classList = `${classList} ${styles.primaryBold}`;
    }
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({
      ref: ref,
      className: classList
    }, props));
  });
  process.env.NODE_ENV !== "production" ? NewComponent.propTypes = {
    bold: PropTypes.bool,
    className: PropTypes.string
  } : void 0;
  NewComponent.defaultProps = {
    bold: false,
    className: ''
  };
  return NewComponent;
};
export default withWeightModifiers;